import { appConfig, headerConfig, refineHeader } from "../../config";

export const termsPolicyAndContactService = {
  add_static_page,
  get_static_page_list,
  get_static_page_details,
  get_becomeapartner_details
};

function add_static_page(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    IDBTransaction,
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}static-pages/save`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function get_static_page_list(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}static-pages/list`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function get_static_page_details(postData) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      secretkey: appConfig.site.secret_key,
      "Access-Control-Allow-Origin": "*"
    },
    mode: "cors",
    IDBTransaction,
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}front-pages/static-pages`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}


function get_becomeapartner_details() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      secretkey: appConfig.site.secret_key,
      "Access-Control-Allow-Origin": "*"
    },
    mode: "cors",
    IDBTransaction,
    // body: JSON.stringify()
  };

  return fetch(`${appConfig.api.url}front-pages/become-a-partner`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      alert(error)
      return Promise.reject(error);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/termsPolicyAndContactService.js